"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavLink = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledBaseComponents = require("styled-base-components");

var _styledConfig = require("styled-config");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  padding: ", ";\n  border: ", " ", ";\n  &:hover,\n  &:focus {\n    text-decoration: none;\n  };\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n    border-top-left-radius: ", ";\n    border-top-right-radius: ", ";\n  "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n      border-radius: ", ";\n    "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n      border-radius: ", ";\n    "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n      background-color: ", ";\n    "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n      &:hover,\n      &:focus {\n        border-color: ", ";\n      };\n    "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n      border-color: ", ";\n    "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n      border-color: ", ";\n    "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    background-color: ", ";\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    color: ", ";\n    &:hover,\n    &:focus {\n      color: ", ";\n    };\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      color: ", ";\n      &:hover,\n      &:focus {\n        color: ", ";\n      };\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      color: ", ";\n      &:hover,\n      &:focus {\n        color: ", ";\n      };\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n      color: ", ";\n      &:hover,\n      &:focus {\n        color: ", ";\n      };\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var color = function color(props) {
  if (props.disabled) {
    return (0, _styledComponents.css)(_templateObject(), (0, _styledConfig.getColor)(props, 'navLink', 'colorDisabled'), (0, _styledConfig.getColor)(props, 'navLink', 'colorDisabledHoverFocus'));
  } else if (props.tabs && props.active) {
    return (0, _styledComponents.css)(_templateObject2(), (0, _styledConfig.getColor)(props, 'navLink', 'colorTabsActive'), (0, _styledConfig.getColor)(props, 'navLink', 'colorTabsActiveHoverFocus'));
  } else if (props.pills && props.active) {
    return (0, _styledComponents.css)(_templateObject3(), (0, _styledConfig.getColor)(props, 'navLink', 'colorPillsActive'), (0, _styledConfig.getColor)(props, 'navLink', 'colorPillsActiveHoverFocus'));
  }

  return (0, _styledComponents.css)(_templateObject4(), (0, _styledConfig.getColor)(props, 'navLink', 'color'), (0, _styledConfig.getColor)(props, 'navLink', 'colorHoverFocus'));
};

var backgroundColor = function backgroundColor(props) {
  return props.pills && props.active && (0, _styledComponents.css)(_templateObject5(), (0, _styledConfig.getColor)(props, 'navLink', 'backgroundColorPillsActive'));
};

var border = function border(props) {
  if (props.tabs && props.active) {
    return (0, _styledComponents.css)(_templateObject6(), (0, _styledConfig.getColor)(props, 'navLink', 'borderColorTabsActive'));
  }

  if (props.tabs && props.disabled) {
    return (0, _styledComponents.css)(_templateObject7(), (0, _styledConfig.getColor)(props, 'navLink', 'borderColorTabsDisabled'));
  } else if (props.tabs) {
    return (0, _styledComponents.css)(_templateObject8(), (0, _styledConfig.getColor)(props, 'navLink', 'borderColorTabsHoverFocus'));
  } else if (props.pills && props.active) {
    return (0, _styledComponents.css)(_templateObject9(), (0, _styledConfig.getColor)(props, 'navLink', 'borderColorPillsActive'));
  }

  return '';
};

var borderRadius = function borderRadius(props) {
  if (props.noRadius) {
    return (0, _styledComponents.css)(_templateObject10(), (0, _styledConfig.getBorderRadius)(props, 'navLink', 'noRadius'));
  } else if (props.pills && props.active) {
    return (0, _styledComponents.css)(_templateObject11(), (0, _styledConfig.getBorderRadius)(props, 'navLink', 'default'));
  }

  return (0, _styledComponents.css)(_templateObject12(), (0, _styledConfig.getBorderRadius)(props, 'navLink', 'default'), (0, _styledConfig.getBorderRadius)(props, 'navLink', 'default'));
};

var NavLink = (0, _styledComponents.default)(_styledBaseComponents.A)(_templateObject13(), function (props) {
  return (0, _styledConfig.getPadding)(props, 'navLink', 'default');
}, function (props) {
  return (0, _styledConfig.getBorder)(props, 'navLink', 'default');
}, function (props) {
  return (0, _styledConfig.getColor)(props, 'navLink', 'borderColor');
}, function (props) {
  return color(props);
}, function (props) {
  return backgroundColor(props);
}, function (props) {
  return border(props);
}, function (props) {
  return borderRadius(props);
});
exports.NavLink = NavLink;
NavLink.defaultProps = {
  theme: _styledConfig.theme
};